import React from 'react'
import './App.css'
import { HashRouter, Switch, Route } from 'react-router-dom'
import mainConfig from './config'
import HomeView from './views/homeView'
import RoadmapView from './views/roadmapView'
import StyleProvider from './components/styleProvider'

const App = () => (
    <>
      <HashRouter>
          <Switch>
              <Route exact path={'/'} component={HomeView}/>
              {
                  mainConfig.map(game => (
                      <Route key={game.slug} path={`/${game.slug}`} name={game.name}>
                          <StyleProvider gameSlug={game.slug}>
                              <RoadmapView config={game.config}/>
                          </StyleProvider>
                      </Route>
                  ))
              }
          </Switch>
      </HashRouter>
    </>
)

export default App;
